






















































































































import Vue from 'vue'
import { Stack, FindStacks, Parameter, FindParameter } from '@/api/cems'
import DateTimePicker1 from '@/components/date-time-picker/dt-picker1.vue'
export default Vue.extend({
  name: 'Toolbar',
  components: { DateTimePicker1 },
  props: {
    loading: Boolean,
  },
  data() {
    return {
      optsAverage: [
        { value: 'auto', text: 'Auto' },
        { value: '1s', text: '1 second' },
        { value: '5s', text: '5 seconds' },
        { value: '15s', text: '15 seconds' },
        { value: '30s', text: '30 seconds' },
        { value: '60s', text: '60 seconds' },
        { value: '5m', text: '5 minutes' },
        { value: '15m', text: '15 minutes' },
        { value: '30m', text: '30 minutes' },
        { value: '1h', text: '1 hour' },
        { value: '1d,7h', text: '1 day' },
      ],
      optsRefreh: [
        { value: 0, text: 'Off' },
        { value: 3000, text: '3s' },
        { value: 5000, text: '5s' },
        { value: 10000, text: '10s' },
        { value: 30000, text: '30s' },
        { value: 60000, text: '1m' },
        { value: 300000, text: '5m' },
        { value: 600000, text: '10m' },
        { value: 3600000, text: '1h' },
      ],
      stacks: [] as Stack[],
      selectedParameters: [] as string[],
      parameters: [] as Parameter[],
      dateTimeRange: ['', ''],
      stackUID: '',
      refreshInterval: 5000,
      avg: '60s',
      printing: false,
      timerRun: false,
      chartStyle: 'single',
    }
  },
  methods: {
    async findStacks() {
      this.stacks = await FindStacks()
    },

    async findParameter() {
      this.parameters = await FindParameter(this.stackUID)
    },

    onApplyCustomTimeRange() {
      this.timerRun = false
      this.refreshInterval = 0
    },

    onRefreshClick() {
      this.$emit('update', {
        avg: this.avg,
        stackUID: this.stackUID,
        from: this.dateTimeRange[0],
        to: this.dateTimeRange[1],
        chartStyle: this.chartStyle,
      })
    },

    updateQuery(query: { [key: string]: string | string[] }) {
      this.$router
        .replace({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            from: this.dateTimeRange[0],
            to: this.dateTimeRange[1],
            avg: this.avg,
            chartStyle: this.chartStyle,
            ...query,
          },
        })
        .catch((error: { name: string }) => {
          if (error.name != 'NavigationDuplicated') {
            throw error
          }
        })
    },

    autoRefresh() {
      if (this.timerRun) {
        return
      }

      if (this.refreshInterval == 0) {
        return
      }

      this.timerRun = true

      setTimeout(() => {
        this.onRefreshClick()

        this.timerRun = false
        this.autoRefresh()
      }, this.refreshInterval)
    },

    setChartStyle(style: string) {
      this.chartStyle = style
    },
  },

  watch: {
    refreshInterval: function() {
      this.autoRefresh()
    },
    stackUID: function(val: string) {
      this.updateQuery({ stackUID: val, avg: this.avg })
      this.findParameter()
    },
    dateTimeRange: function(val: string[]) {
      this.updateQuery({ from: val[0], to: val[1] })
    },
    avg: function(avg: string) {
      this.updateQuery({ avg })
    },
    selectedParameters: function(val: string[]) {
      this.updateQuery({ parameters: val })
    },
    chartStyle: function(val: string) {
      this.updateQuery({ chartStyle: val })
    },
  },

  async created() {
    if (this.$route.query && this.$route.query.parameters) {
      this.selectedParameters = JSON.parse(
        JSON.stringify(this.$route.query.parameters)
      )
    }
    await this.findStacks()

    if (this.stackUID == '' && this.stacks.length > 0) {
      this.stackUID = this.stacks[0].uid
    }

    // this.selectedParameters = { ...this.$route.query.parameters }

    this.onRefreshClick()
    this.autoRefresh()
  },
})
